import { render, staticRenderFns } from "./AddressResult.vue?vue&type=template&id=0fd07906"
import script from "./AddressResult.vue?vue&type=script&lang=js"
export * from "./AddressResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fd07906')) {
      api.createRecord('0fd07906', component.options)
    } else {
      api.reload('0fd07906', component.options)
    }
    module.hot.accept("./AddressResult.vue?vue&type=template&id=0fd07906", function () {
      api.rerender('0fd07906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/open_popup/AddressResult.vue"
export default component.exports